<p-pickList [source]="filteredSource"
            [(target)]="target"
            [filterBy]="displayField"
            [responsive]="responsive"
            [disabled]="disabled"
            (onMoveToTarget)="onMoveToTarget()"
            (onMoveToSource)="onMoveToSource()"
            [dragdrop]="dragDrop && !disabled"
            [sourceHeader]="sourceHeader" [targetHeader]="targetHeader"
            [sourceFilterPlaceholder]="sourceFilterPlaceholder" [targetFilterPlaceholder]="targetFilterPlaceholder">
    <ng-template let-record pTemplate="item">
        <div class="p-picklist-record">
            <app-icon *ngIf="icon" library="material" [variant]="icon" simple="true"></app-icon>
            {{ record[displayField] }}
            <app-tooltip *ngIf="hasTooltip"
                         type="info"
                         displayType="equipment"
                         [record]="record"></app-tooltip>
        </div>
    </ng-template>
</p-pickList>
<app-form-error-list *ngIf="showValidations"
                     [errorMap]="formControl.errors"></app-form-error-list>
